import __request__ from "routing/request";
export function requestGet(path, hostname) {
  return __request__("GET", `/datanodes/${hostname}/rest/${path}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function requestPost(path, hostname) {
  return __request__("POST", `/datanodes/${hostname}/rest/${path}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function requestPut(path, hostname) {
  return __request__("PUT", `/datanodes/${hostname}/rest/${path}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function requestDelete(path, hostname) {
  return __request__("DELETE", `/datanodes/${hostname}/rest/${path}`, null, {}, {
    "Accept": ["application/json"]
  });
}
